import { render, staticRenderFns } from "./InvoiceHistorical.vue?vue&type=template&id=7788e9d3&scoped=true"
import script from "./InvoiceHistorical.vue?vue&type=script&lang=js"
export * from "./InvoiceHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788e9d3",
  null
  
)

export default component.exports